import React, { useEffect } from "react";
import "./footer.css";

const Footer: React.FC = () => {
  useEffect(() => {
    const el = document.getElementById("y");
    if (el) el.textContent = String(new Date().getFullYear());
  }, []);

  return (
    <footer className="footer">
      <div className="container cols">
        <div>
          <strong>ProfitOption</strong>
          <br />
          <span>
            © <span id="y"></span> All rights reserved.
          </span>
          <br />
          <small className="muted">
            Risk warning: trading derivatives involves high risk. Ensure you
            understand the risks and comply with the laws of your jurisdiction.
          </small>
        </div>
        <div>
          <div className="muted">Company</div>
          <a className="link" href="#">
            About
          </a>
          <br />
          <a className="link" href="#">
            Contacts
          </a>
          <br />
          <a className="link" href="#">
            Affiliates
          </a>
        </div>
        <div>
          <div className="muted">Legal</div>
          <a className="link" href="#">
            User Agreement
          </a>
          <br />
          <a className="link" href="#">
            Privacy Policy
          </a>
          <br />
          <a className="link" href="#">
            KYC/AML Policy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
